<template>
  <div>
    <CChartBar :datasets="dataSet" :options="options" :labels="label" />
  </div> 
</template>

<script>
import { CChartBar } from "@coreui/vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils/src";

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default {
  name: "ChartBar",
  components: {
    CChartBar,
  },
  props: {
    dataSet: {
      type: [Array, Object],
      default: () => [],
    },
    label: {
      type: [Array, Object],
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        tooltips: {
          callbacks: {
            title:function(tooltipItem,data){
              return 'Tanggal ' + data['labels'][tooltipItem[0]['index']];
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                userCallback(label, index, labels) {
                  // only show if whole number
                  if (Math.floor(label) === label) {
                      return label;
                  }
                },
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
          },
        },
      },
    };
  },
};
</script>
